module.exports = __webpack_public_path__ + "static/media/日历5@2x.9f0bfdba.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_145/img/日历5@2x.png
// module id = 1378
// module chunks = 0